module.exports = __webpack_public_path__ + "9f2b9d41d07770c0ca6200060411dc09.jpg";